import { KeyboardBackspace } from "@mui/icons-material";
import { Container, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "src/hooks/useIsMobile";
import FrequentlyAskedQuestions from "./components/FrequentlyAskedQuestions";
import { useTranslation } from "react-i18next";

const HelpCenter = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const page = "account.help-center";

  return (
    <Container maxWidth="xl" disableGutters>
      <Stack gap={2}>
        <Stack direction="row" alignItems="center">
          {isMobile ? (
            <IconButton sx={{ color: "#00B6B8" }} onClick={() => navigate(-1)}>
              <KeyboardBackspace fontSize="large" />
            </IconButton>
          ) : null}
          <Stack gap={1}>
            <Typography variant="h5" fontWeight={700}>
              {t(`${page}.header`)}
            </Typography>
            <Typography variant="subtitle1">{t(`${page}.subtext`)}</Typography>
          </Stack>
        </Stack>

        <FrequentlyAskedQuestions page={page} />
      </Stack>
    </Container>
  );
};

export default HelpCenter;
